<template>
    <div class="chaoozeRegion">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane :label="$t(item.label)" v-for="item in tabArray" :key="item.value" :name="item.value"></el-tab-pane>
        </el-tabs>
        <div class="choozeContent">
            <el-form :model="choozeQuery" inline>
                <el-form-item :label="$t('integration.equipment_type')">
                    <el-select v-model="choozeQuery.dev" :placeholder="$t('integration.please_select_a_device_type')" clearable>
                        <el-option v-for="item in typeArray" :key="item.id" :label="$t('deviceType.' + item.name)" :value="item.id">
                            <span style="margin-right: 10px;">
                                <i :class="item.icon"></i>
                            </span>
                            <span>{{ $t('deviceType.' + item.name) }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('integration.no_dot_/name')">
                    <el-input type="text" clearable v-model="choozeQuery.name" :placeholder="$t('integration.please_enter_the_number_or_name')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('public.time')">
                    <!-- <el-input type="text" v-model="searchForm.time"></el-input> -->
                    <el-date-picker
                        style="width:250px"
                        v-model="time"
                        type="datetimerange"
                        :start-placeholder="$t('public.start_date')"
                        :end-placeholder="$t('public.end_date')"
                        :default-time="['12:00:00']"
                    ></el-date-picker>
                    <el-button type="primary" icon="el-icon-search" @click="searchFn"></el-button>
                </el-form-item>
            </el-form>
            <el-table
                stripe
                :data="tableData"
                v-loading="loading"
                ref="multipleTable"
                :header-cell-style="headCellStyle"
                :height="tableHeight"
                highlight-current-row
                @selection-change="handleSelectionChange"
                @select="onSelect"
                @select-all="selectAll"
            >
                <el-table-column :label="$t('integration.equipment_name/no')" prop="deviceName" show-overflow-tooltip>
                    <template #default="{ row }">
                        <i :class="equiIconConvert(row.deviceCatalog, row.deviceType).icon" class="icon-margin" :title="$t(equiIconConvert(row.deviceCatalog, row.deviceType).title)"></i>
                        <span>{{ row.carrierDeviceName }}</span>
                    </template>
                </el-table-column>
                <!-- 数据异常存在 -->
                <template v-if="isDataAb">
                    <el-table-column :label="$t('public.data')" prop="reasonText" show-overflow-tooltip>
                        <template #default="{ row }">
                            <span>{{ dataFn(row.content) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('integration.monitoring_interval')" prop="reasonText" show-overflow-tooltip>
                        <template #default="{ row }">
                            <span>{{ reginFn(row) }}</span>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column :label="$t('public.time')" prop="recordTime" show-overflow-tooltip>
                    <template #default="{ row }">
                        <span style="line-height: 34px;">{{ $timetransition(row.recordTime) }}</span>
                    </template>
                </el-table-column>
                <el-table-column type="selection" width="50" align="center"> </el-table-column>
                <!-- <el-table-column :label="$t('public.choose')" prop="reasonText" width="100px" align="left">
          <template #default="{ row }">
            <div class="checkClass">
              <el-checkbox v-model="row.checked" @change="checkFn($event, row)"></el-checkbox>
            </div>
          </template>
        </el-table-column> -->
            </el-table>
            <Pagination
                class="pagination"
                :iDisplayLength="5"
                :pageSizes="[5]"
                :total="total"
                :page.sync="choozeQuery.iDisplayStart"
                :limit.sync="choozeQuery.iDisplayLength"
                @pagination="getListFn"
            ></Pagination>
        </div>
    </div>
</template>

<script>
import { exTab, exDev } from '@/api/modules/abnormal.js';
import { DEVICE_TYPE_ICON_FN } from '@/utils/iconMatch.js';
import { equiIconConvert } from '@/utils/convert';
export default {
    props: ['rowData', 'childrenList'],
    data() {
        return {
            equiIconConvert,
            activeName: 'link',
            tabArray: [
                {
                    value: 'link',
                    label: this.$t('device.conn_abnormal')
                },
                {
                    value: 'data',
                    label: $t('public.ex_data')
                },
                {
                    value: 'power',
                    label: $t('public.ex_power')
                }
            ],
            // 匹配icon
            iconArray: [
                // 传感器
                {
                    deviceID: 'sensor-zbp_1',
                    icon: 'iconfont icon-wenduji'
                },
                {
                    deviceID: 'sensor-zbp_2',
                    icon: 'iconfont icon-wenshiduji'
                },
                {
                    deviceID: 'sensor-lora_1',
                    icon: 'iconfont icon-wenduji1'
                },
                {
                    deviceID: 'sensor-lora_2',
                    icon: 'iconfont icon-wenshiduji1'
                },
                {
                    deviceID: 'sensor-zeta_1',
                    icon: 'iconfont icon-21pingjunqiwen'
                },
                {
                    deviceID: 'sensor-zeta_2',
                    icon: 'iconfont icon-wenshiduji2'
                },
                // 路由
                {
                    deviceID: 'gateway-gt_1',
                    icon: 'iconfont icon-wangguan'
                },
                {
                    deviceID: 'gateway-gt_2',
                    icon: 'el-icon-monitor'
                },
                // 网关
                {
                    deviceID: 'display-dt_1',
                    icon: 'iconfont icon-lcd'
                },
                // 中继
                {
                    deviceID: 'relay-rt_1',
                    icon: 'el-icon-s-operation'
                }
            ],
            loading: false,
            typeArray: [],
            tableData: [],
            tableHeight: '250px',
            total: 0,
            choozeQuery: {
                dev: null,
                name: null,
                iDisplayStart: 0,
                iDisplayLength: 5,
                exId: null,
                tab: 'link'
            },
            isDataAb: false,
            time: [],
            isCheck: false,

            // 是否是可编辑模式
            isEdit: true
        };
    },
    watch: {
        childrenList(newVal) {
            console.log(newVal);
            this.$refs['multipleTable'].clearSelection();
            this.tableData.forEach(item => {
                [...newVal].forEach(async opt => {
                    if (item.id === opt.id) {
                        await this.$nextTick();
                        this.$refs['multipleTable'].toggleRowSelection(item, true);
                    }
                });
            });
        }
    },
    mounted() {
        this.getDev();
        this.getListFn();
    },
    methods: {
        // 获取设备目录
        getDev() {
            exDev().then(({ result }) => {
                this.typeArray = result.map(item => {
                    let array = item['code'].split('-');

                    this.iconArray.forEach(opt => {
                        if (opt.deviceID === item['code']) {
                            this.$set(item, 'icon', opt.icon);
                        }
                    });
                    return {
                        id: item.id,
                        name: array[1],
                        icon: item.icon
                    };
                });
                this.activeName = 'link';
            });
        },
        // 获取数据
        getListFn() {
            return new Promise((resolve, reject) => {
                this.loading = true;
                this.choozeQuery.exId = this.rowData.id;
                exTab(this.choozeQuery)
                    .then(res => {
                        this.tableData = res.result;
                        this.total = res.pageInfo.total;
                        resolve();
                    })
                    .catch(err => {
                        reject(err);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            });
        },

        async handleClick({ name }) {
            this.reasetFn();

            this.loading = true;
            this.isDataAb = name === 'data';
            this.choozeQuery.tab = name;

            await this.getListFn();
            // 勾选记忆
            const { getAbList } = this.$parent;
            if (getAbList.length > 0) {
                this.tableData.forEach(item => {
                    getAbList.forEach(async opt => {
                        if (item.id === opt.id) {
                            await this.$nextTick();
                            this.$refs['multipleTable'].toggleRowSelection(item, true);
                        }
                    });
                });
            }
        },
        reasetFn() {
            this.tableData = [];
            this.time = [];
            (this.choozeQuery.dev = null), (this.choozeQuery.name = null);
        },
        dataFn(content) {
            if (content) {
                content = content.replace(/\\/g, '');
                let JSONContent = JSON.parse(content);
                return JSONContent.val + JSONContent.unit;
            }
        },
        reginFn(row) {
            if (row.content) {
                row.content = row.content.replace(/\\/g, '');
                let JsonContent = JSON.parse(row.content);
                return `${JsonContent.min + JsonContent.unit}-${JsonContent.max + JsonContent.unit}`;
            }
        },
        searchFn() {
            this.choozeQuery.exId = this.rowData.id;
            if (this.time.length > 0) {
                let from = this.$dateParseTime(this.time[0]);
                let to = this.$dateParseTime(this.time[1]);

                this.$set(this.choozeQuery, 'from', from);
                this.$set(this.choozeQuery, 'to', to);
            }

            this.loading = true;
            exTab(this.choozeQuery)
                .then(({ result }) => {
                    this.tableData = result;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        deviceTypeFn(type, catalog) {
            switch (catalog) {
                case 0: {
                    return DEVICE_TYPE_ICON_FN('sensor', type, 'icon');
                }
                case 1: {
                    return DEVICE_TYPE_ICON_FN('gateway', type, 'icon');
                }
                case 2: {
                    return DEVICE_TYPE_ICON_FN('display', type, 'icon');
                }
                case 3: {
                    return DEVICE_TYPE_ICON_FN('delay', type, 'icon');
                }
                default:
                    break;
            }
        },
        deviceTitleFn(type, catalog) {
            switch (catalog) {
                case 0: {
                    return DEVICE_TYPE_ICON_FN('sensor', type, 'title');
                }
                case 1: {
                    return DEVICE_TYPE_ICON_FN('gateway', type, 'title');
                }
                case 2: {
                    return DEVICE_TYPE_ICON_FN('display', type, 'title');
                }
                case 3: {
                    return DEVICE_TYPE_ICON_FN('delay', type, 'title');
                }
                default:
                    break;
            }
        },
        handleSelectionChange(row) {
            // this.$emit('pushDataFn', row)
        },
        onSelect(rows, row) {
            let selected = rows.length && rows.indexOf(row) !== -1;
            // console.log(selected)  // true就是选中，0或者false是取消选中
            this.$emit('pushDataFn', rows, row, selected);
        },
        selectAll(rows) {
            if (rows.length === 0) {
                this.$emit('pushDataFn', this.tableData, {}, 'allCancel');
            } else {
                this.$emit('pushDataFn', rows, {}, true);
            }
        }
        // 同步进行选择
        // checkFn(event, row) {
        //   // if(event) return  this.$message.warning($t('integration.now_in_viewing_status_c__please_return_to_processing_status')),row.checked = null;
        //   if (!this.isEdit)
        //     return (
        //       this.$message.warning($t('integration.now_in_viewing_status_c__please_return_to_processing_status')),
        //       (row.checked = false)
        //     )
        //   // bus.$emit('isShowText', false);
        //   // bus.$emit('pushDataFn', row)
        //   this.$emit('pushDataFn', row)
        // }
    }
};
</script>

<style lang="scss" scoped>
.chaoozeRegion {
    min-height: 300px;

    .checkClass {
        line-height: 36px;
    }

    .pagination {
        padding-top: 0;
        padding-right: 15px !important;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    background-color: var(--primary-color);
    color: #fff;
}
</style>
